import { useEffect } from "react";

const SITE_NAME = "Vista360 NG";
const DEFAULT_URL = "https://www.vista360.ng";
const DEFAULT_IMAGE = "https://www.vista360.ng/og-image.jpg";

type SeoInput = {
  title: string;
  description: string;
  path?: string;
  image?: string;
  noindex?: boolean;
};

function ensureMeta(attr: "name" | "property", key: string, value: string) {
  let meta = document.head.querySelector(`meta[${attr}='${key}']`) as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attr, key);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", value);
}

function ensureCanonical(href: string) {
  let canonical = document.head.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", href);
}

export function usePageSeo({ title, description, path = "/", image = DEFAULT_IMAGE, noindex = false }: SeoInput) {
  useEffect(() => {
    const canonicalUrl = `${DEFAULT_URL}${path === "/" ? "" : path}`;
    const fullTitle = `${title} | ${SITE_NAME}`;

    document.title = fullTitle;

    ensureMeta("name", "description", description);
    ensureMeta("name", "twitter:card", "summary_large_image");
    ensureMeta("name", "twitter:title", fullTitle);
    ensureMeta("name", "twitter:description", description);
    ensureMeta("name", "twitter:image", image);
    ensureMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    ensureMeta("property", "og:title", fullTitle);
    ensureMeta("property", "og:description", description);
    ensureMeta("property", "og:type", "website");
    ensureMeta("property", "og:url", canonicalUrl);
    ensureMeta("property", "og:image", image);
    ensureMeta("property", "og:site_name", SITE_NAME);

    ensureCanonical(canonicalUrl);
  }, [description, image, noindex, path, title]);
}
